import PropTypes from 'prop-types';
import './LotusLamp.css';

/**
 * 3D 蓮花燈組件 - 帶火焰效果
 * 3D Lotus Lamp Component with Flame
 */
const LotusLamp = ({ size = 'md', className = '' }) => {
    const sizes = {
        sm: { scale: 0.7 },
        md: { scale: 1 },
        lg: { scale: 1.3 },
    };

    const currentSize = sizes[size];

    return (
        <div
            className={`lotus-lamp-container ${className}`}
            style={{
                transform: `scale(${currentSize.scale})`,
            }}
        >
            {/* 3D 火焰 */}
            <div className="flame-3d">
                <div className="flame-layer flame-outer"></div>
                <div className="flame-layer flame-middle"></div>
                <div className="flame-layer flame-inner"></div>
                <div className="flame-core"></div>
            </div>

            {/* SVG 漸變定義 */}
            <svg className="gradient-svg" style={{ opacity: 0, height: 0, width: 0 }}>
                <defs>
                    <radialGradient cx="50%" cy="5%" fx="50%" fy="5%" r="110%" id="lotus-gradient">
                        <stop stopColor="#FFFEF8" offset="0%" />
                        <stop stopColor="#F5E6D3" offset="50%" />
                        <stop stopColor="#D4B896" offset="100%" />
                    </radialGradient>
                </defs>
            </svg>

            {/* 3D 蓮花容器 */}
            <div className="lotus-wrapper">
                {/* 外層 8 片花瓣 */}
                <div className="lotus lotus-outer">
                    <ul>
                        {[...Array(8)].map((_, i) => (
                            <li key={i} style={{ transform: `rotateZ(${i * 45}deg) rotateX(15deg) rotateY(5deg)` }}>
                                <svg viewBox="0 0 72 200">
                                    <path d="M0,100 C0,66.6666667 12,33.3333333 36,0 C60,33.3333333 72,66.6666667 72,100 C72,133.333333 60,166.666667 36,200 C12,166.666667 0,133.333333 0,100 Z" />
                                </svg>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* 中層 6 片花瓣 */}
                <div className="lotus lotus-middle">
                    <ul>
                        {[...Array(6)].map((_, i) => (
                            <li key={i} style={{ transform: `rotateZ(${i * 60}deg) rotateX(30deg) rotateY(5deg)` }}>
                                <svg viewBox="0 0 72 200">
                                    <path d="M0,100 C0,66.6666667 12,33.3333333 36,0 C60,33.3333333 72,66.6666667 72,100 C72,133.333333 60,166.666667 36,200 C12,166.666667 0,133.333333 0,100 Z" />
                                </svg>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* 內層 3 片花瓣 */}
                <div className="lotus lotus-inner">
                    <ul>
                        {[...Array(3)].map((_, i) => (
                            <li key={i} style={{ transform: `rotateZ(${i * 120}deg) rotateX(60deg) rotateY(5deg)` }}>
                                <svg viewBox="0 0 72 200">
                                    <path d="M0,100 C0,66.6666667 12,33.3333333 36,0 C60,33.3333333 72,66.6666667 72,100 C72,133.333333 60,166.666667 36,200 C12,166.666667 0,133.333333 0,100 Z" />
                                </svg>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

LotusLamp.propTypes = {
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    className: PropTypes.string,
};

export default LotusLamp;
